import React, { ReactNode } from "react";
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { closeModal, isModalActive } from "../../store/modal.slice";

interface IBaseModal {
    children: ReactNode;
    name: string;
    title: string;
    baseClass: string;
    topupLvl: number;
    afterOpen?: () => void;
    onClose?: () => void;
    shouldCloseOnEsc?: boolean;
    shouldCloseOnOverlayClick?: boolean;
};
ReactModal.setAppElement('#root');
export const Modal = (props: IBaseModal) => {
    const { children, name, title, baseClass, topupLvl, afterOpen, onClose, shouldCloseOnEsc = true, shouldCloseOnOverlayClick = true } = props;

    const dispatch = useDispatch();
    const isModalVisible = useSelector(isModalActive(name));

    const afterOpenModal = () => {
        if (afterOpen) afterOpen();
    };

    const onCloseModal = () => {
        if (onClose) onClose();
        dispatch(closeModal(name));
    };

    return (
        <ReactModal
            id={name}
            isOpen={isModalVisible}
            onAfterOpen={afterOpenModal}
            onRequestClose={onCloseModal}
            contentLabel={title}
            overlayClassName={`modal__overlay ${topupLvl ? `modal__overlay__topup-${topupLvl}` : ''} ${baseClass}__modal__overlay`}
            className={`modal__dialog ${topupLvl ? `modal__dialog__topup-${topupLvl}` : ''} ${baseClass}__modal__dialog`}
            shouldCloseOnEsc={shouldCloseOnEsc}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            <div className={`modal__content ${baseClass}__modal__content`}>
                {children}
            </div>
        </ReactModal>
    );
};